angular.module("UI8.components").component("featuredAuthor", {
  template: `
    <div class="author">
      <div class="author__border" id="author-card-border"></div>
      <div class="author__inner">
        <div class="author__products">
          <a
            ng-repeat="product in $ctrl.products track by product._id"
            href="/{{ $ctrl.author.display_name_slug }}/products/{{ product.slug }}"
          >
            <img ng-src="{{ product.card_image }}" alt="{{ product.name }}" loading="lazy">
          </a>
        </div>
        <div class="author__footer">
          <a class="author__avatar" href="{{ $ctrl.authorUrl }}">
            <div class="author__avatar-border" id="author-avatar-border"></div>
            <div class="author__avatar-inner">
              <img ng-src="{{ $ctrl.author.avatar_url }}" alt="Avatar" loading="lazy">
            </div>
          </a>
          <div class="author__content">
            <a class="author__name" href="{{ $ctrl.authorUrl }}">{{ $ctrl.author.display_name }}</a>
            <p class="author__bio">{{ $ctrl.author.biography }}</p>
          </div>
          <button
            class="btn btn--stroke"
            ui8-follow-button="{{ $ctrl.author._id }}"
            ui8-default-class="btn--stroke"
          >
            Follow
          </button>
        </div>
      </div>
    </div>
  `,

  controller: function ($element) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.author = ctrl.products[0].author;
      ctrl.authorUrl = `/${ctrl.author.display_name_slug}/products`;
    };

    ctrl.$postLink = function () {
      if (!window.AuthorShaders) return;
      var el = $element[0];
      var obs = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            obs.disconnect();

            window.AuthorShaders.initAuthorCardBorder(
              el.querySelector("#author-card-border")
            );

            window.AuthorShaders.initAuthorAvatarBorder(
              el.querySelector("#author-avatar-border")
            );
          }
        },
        { rootMargin: "200px" }
      );
      obs.observe(el);
    };
  },

  bindings: {
    products: "<",
    user: "<",
  },
});
